import Vue from 'vue';
import DaraIcon from '@/components/icon/Icon.vue';
import DaraForm from '@/components/form/Form.vue';
import DaraInput from '@/components/input/Input.vue';
import DaraTextarea from '@/components/input/Textarea.vue';
import DaraNavbar from '@/components/navbar/Navbar.vue';
import DaraTopbar from '@/components/topbar/Topbar.vue';
import DaraPagination from '@/components/pagination/Pagination.vue';
import DaraSelect from '@/components/select/Select.vue';
import DaraTable from '@/components/table/Table.vue';
import DaraTagInput from '@/components/tag-input/TagInput.vue';
import DaraModal from '@/components/modal/Modal.vue';
import DaraModalConfirm from '@/components/modal/ModalConfirm.vue';
import DaraModalDelete from '@/components/modal/ModalDelete.vue';
import DaraModalDeleteDepartment from '@/components/modal/ModalDeleteDepartment.vue';
import DaraModalNewDepartment from '@/components/modal/ModalNewDepartment.vue';
import DaraModalChangePassword from '@/components/modal/ModalChangePassword.vue';
import DaraModalWarning from '@/components/modal/ModalWarningNewUrl.vue';
import DaraAvatar from '@/components/avatar/Avatar.vue';
import DaraTag from '@/components/tag/Tag.vue';
import DaraInvisible from '@/components/invisible/Invisible.vue';
import DaraImage from '@/components/image/Image.vue';
import DaraButton from '@/components/button/Button.vue';
import DaraRating from '@/components/rating/Rating.vue';
import DaraEmpty from '@/components/empty/Empty.vue';
import DaraDraggable from '@/components/draggable/Draggable.vue';
import DaraArticleLink from '@/modules/article/components/ArticleLink.vue';
import DaraTrackLink from '@/modules/track/components/TrackLink.vue';
import DaraQuestionLink from '@/modules/question/components/QuestionLink.vue';

// Containers
import DaraRow from '@/components/container/Row.vue';
import DaraCol from '@/components/container/Column.vue';
import DaraContainer from '@/components/container/Container.vue';

// Typography
import DaraP from '@/components/typography/Paragraph.vue';
import DaraSmall from '@/components/typography/Small.vue';
import DaraHeader from '@/components/typography/Header.vue';

const components = {
  DaraIcon,
  DaraForm,
  DaraInput,
  DaraTextarea,
  DaraNavbar,
  DaraTopbar,
  DaraPagination,
  DaraSelect,
  DaraTable,
  DaraTagInput,
  DaraModal,
  DaraModalConfirm,
  DaraModalDelete,
  DaraModalDeleteDepartment,
  DaraModalNewDepartment,
  DaraModalChangePassword,
  DaraModalWarning,
  DaraAvatar,
  DaraTag,
  DaraInvisible,
  DaraImage,
  DaraButton,
  DaraRating,
  DaraEmpty,
  DaraDraggable,
  DaraArticleLink,
  DaraTrackLink,
  DaraQuestionLink,

  // Containers
  DaraRow,
  DaraCol,
  DaraContainer,

  // Typography
  DaraP,
  DaraSmall,
  DaraHeader,
};

Object.entries(components).forEach(([name, component]) => Vue.component(name, component));
